<div class="flex flex-1 flex-col">
  <pms-container [load]="loadFn" (data)="onData($event)">
    <div *containerContent class="flex flex-1 flex-col">
      @for (clinicCase of clinicalCaseItems; track $index) {
        @if (!$first) {
          <div #scrollAnchor class="flex flex-row justify-center">
            <div
              class="h-12 w-px border-l-2 border-dashed border-slate-200"
            ></div>
          </div>
        }
        <div
          class="mx-4 flex flex-col gap-1 rounded-md border-2 border-slate-200 p-2 pt-0"
        >
          <div
            class="-mx-2 flex flex-col items-center justify-center gap-0 border-b-2 bg-blue-50 px-2 pt-2"
          >
            <span class="text-md font-medium text-slate-900">{{
              clinicCase.healthRecord.name
            }}</span>
            <div class="flex flex-row gap-1">
              <span class="text-base text-slate-400">{{
                clinicCase.healthRecord.number
              }}</span>

              <span class="text-base text-slate-400">
                {{ clinicCase.healthRecord.performedAt | dayjs: "lll" }}
              </span>

              @if (clinicCase.healthRecord.detail.weight) {
                <span class="text-base text-slate-400">
                  {{ clinicCase.healthRecord.detail.weight }} kg
                </span>
              }
            </div>

            @if ((clinicCase.healthRecord.staff?.length || 0) > 0) {
              <span class="text-base text-slate-600">
                @for (staff of clinicCase.healthRecord.staff; track staff) {
                  {{ staff | customerNominative }}
                }
              </span>
            }
          </div>

          <snt-report-form-renderer
            [healthRecord]="clinicCase.healthRecord"
            [templateConfig]="clinicCase.currentTemplate"
            [dataSource]="clinicCase.soapDesignDataSource"
            [readOnly]="true"
            [hideEmptyFields]="true"
          ></snt-report-form-renderer>
        </div>
      }
    </div>
  </pms-container>
</div>
